import React from 'react'
import useDispatch from 'hooks/use-dispatch'
import loadProductCollectionItemCardLoadAction from 'containers/ProductCollection/components/Item/components/Load/actions/load'

/**
 * @param productVariant
 * @param price
 * @param variantId
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductCollectionItemCardLoad ({
  productVariant,
  price,
  variantId
}) {
  const dispatch = useDispatch()

  const load = () => {
    dispatch(
      loadProductCollectionItemCardLoadAction({
        productVariant,
        price,
        variantId
      })
    )
  }

  const handleUpdate = () => {
    load()
  }

  React.useEffect(() => {
    handleUpdate()
  }, [variantId])

  return <></>
}
